import { render, staticRenderFns } from "./PorProfissional.vue?vue&type=template&id=8373009e&scoped=true"
import script from "./PorProfissional.vue?vue&type=script&lang=js"
export * from "./PorProfissional.vue?vue&type=script&lang=js"
import style0 from "./PorProfissional.vue?vue&type=style&index=0&id=8373009e&prod&scoped=true&lang=scss"
import style1 from "./PorProfissional.vue?vue&type=style&index=1&id=8373009e&prod&lang=css"
import style2 from "./PorProfissional.vue?vue&type=style&index=2&id=8373009e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8373009e",
  null
  
)

export default component.exports